import { useState } from 'react';
// material
import { Container, Typography, Card, Tab, Box, Stack } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import MaterialUsageTable from './MaterialUsageTable';
import MaterialTransaferLogs from './MaterialTransferLogs';

// components

export default function MaterialTableTab({ material, getMaterial }) {
  const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Card>
      <Box sx={{ width: '100%' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange}>
              <Tab label="Summary" value="1" />
              <Tab label="History" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <MaterialUsageTable material={material} getMaterial={getMaterial} />
          </TabPanel>
          <TabPanel value="2">
            <MaterialTransaferLogs material={material} getMaterial={getMaterial} type={"material"} />
          </TabPanel>
        </TabContext>
      </Box>
    </Card>
  );
}
